import React from 'react';

export default () => {
  return (
    <div>
      <h3>Page Not Found</h3>
      
    </div>
  )
}